import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui-kit/tabs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Devices } from '../../components/devices/devices';
import { GeneralInfo } from '../../components/general-info/general-info';

export const ProfilePage = () => {
  const [tabId, setTabId] = useState('generalInfo');
  const { t } = useTranslation();

  return (
    <div className="flex max-w-5xl mx-auto flex-col px-3 py-6 md:px-0 ">
      <div className="mb-2 md:mb-4.5 flex items-center text-base text-high-emphasis">
        <h3 className="text-2xl font-bold tracking-tight">{t('MY_PROFILE')}</h3>
      </div>

      <Tabs value={tabId}>
        <div className="my-3 sm:my-5 flex items-center rounded text-base">
          <TabsList>
            <TabsTrigger onClick={() => setTabId('generalInfo')} value="generalInfo">
              {t('GENERAL_INFO')}
            </TabsTrigger>
            <TabsTrigger onClick={() => setTabId('devices')} value="devices">
              {t('DEVICES')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="generalInfo">
          <GeneralInfo />
        </TabsContent>

        <TabsContent value="devices">
          <Devices />
        </TabsContent>
      </Tabs>
    </div>
  );
};
